'use client';

import { useEffect } from 'react';
import FallbackPage from 'src/components/Layout/ErrorBoundary/FallbackPage';
import { logger, normalizeError } from 'src/helper/logger';

/**
 * Route-group error boundary for the (auth) group. Rendered inside AuthLayout so
 * a failure on a sign-in / sign-up screen shows a recoverable fallback rather
 * than a blank page. "Go Home" is hidden because the auth screens are the
 * unauthenticated entry point; `reset` retries the failed segment.
 */
export default function AuthError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.error('app.route_error', {
      group: 'auth',
      error: normalizeError(error),
      // Include the stack for pure client-render errors where `digest` is
      // undefined and normalizeError only keeps the message.
      stack: error instanceof Error ? error.stack : undefined,
      digest: error.digest,
    });
  }, [error]);

  return <FallbackPage error={error} reset={reset} hideGoHome />;
}
